import { USER_STATUSES } from "utils/helpers/enums/shared.enum";

export class RoleFilterDTO {
  page: number = 1;
  limit: number = 10;
  count: number = 1;
  size: number = 10;
  roleName: string = "";
}
